
export default class Main{

    constructor(){
        this._init();
    }

    _init(){
        
        document.querySelectorAll('.js-nav__item').forEach($item=>{
            $item.addEventListener('click', (e)=>{
                e.stopPropagation();
                $item.classList.toggle('-open');
            });
        });

        document.addEventListener('click', (e)=>{

            document.querySelectorAll('.js-nav__item').forEach($item=>{
                $item.classList.remove('-open');
            });
        });
    }
}